"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importStar(require("react"));
var format_price_1 = __importDefault(require("../../../../../utils/format-price"));
var index_1 = require("../index");
var remove_ships_every_text_1 = __importDefault(require("../../../../../utils/remove-ships-every-text"));
exports.default = (function () {
    var _a = (0, react_1.useContext)(index_1.AppContext), orderToCancel = _a.orderToCancel, cancelReason = _a.cancelReason, setCancelReason = _a.setCancelReason, mainBundleProduct = _a.mainBundleProduct, products = _a.products;
    if (!orderToCancel) {
        return null;
    }
    // to add another cancel reason, simply add to this array
    var cancelReasons = [
        { key: '', name: 'Please select a cancellation reason to submit your request' },
        { key: 'editItems', name: 'Edit Size/Design/Product(s)' },
        { key: 'editShipping', name: 'Edit Shipping Address' },
        { key: 'price', name: 'Price' },
        { key: 'frequency', name: 'Frequency' },
        { key: 'dissatisfied', name: 'Dissatisfied' },
        { key: 'subscriptionUnaware', name: "Wasn't aware it was a subscription" },
        { key: 'other', name: 'Other' },
    ];
    return (react_1.default.createElement("div", { className: 'padding-5' },
        react_1.default.createElement("h5", null, "Order Cancellation Request"),
        react_1.default.createElement("div", { className: 'text-brownish-grey padding-top-3 font-size-14' }, "Need to cancel your order? Submit a request and we\u2019ll try to catch it before it ships!"),
        react_1.default.createElement("div", { className: 'text-brownish-grey padding-top-3 font-size-14' },
            react_1.default.createElement("div", null, "If your order can be cancelled, we\u2019ll refund your payment."),
            react_1.default.createElement("div", null, "If your order is too far along to stop, you can set up a free return once you receive it.")),
        react_1.default.createElement("div", { className: 'padding-top-5' },
            react_1.default.createElement("select", { required: true, name: 'CancelReason', value: cancelReason.key, onChange: function (e) {
                    var targetIndex = e.target.selectedIndex;
                    // if targetIndex is 0, then it is a null placeholder value. so let's set it to undefined to block step progress
                    setCancelReason({ key: e.target.value, name: targetIndex === 0 ? undefined : e.target[targetIndex].textContent });
                }, style: { display: 'block' } }, cancelReasons.map(function (reason) { return (react_1.default.createElement("option", { key: reason.key, value: reason.key }, reason.name)); }))),
        react_1.default.createElement("div", { className: 'bg-white bordered border-very-light-pink padding-vertical-5', style: { borderRadius: '5px' } },
            mainBundleProduct && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("div", { className: 'grid-x' },
                    react_1.default.createElement("div", { className: 'padding-left-3' },
                        react_1.default.createElement("img", { src: mainBundleProduct.image_src, style: { maxHeight: '80px' } })),
                    react_1.default.createElement("div", { className: 'cell auto padding-left-3', style: { margin: 'auto' } }, (0, remove_ships_every_text_1.default)(mainBundleProduct.title))),
                react_1.default.createElement("hr", { className: 'border-seashell' }))), products === null || products === void 0 ? void 0 :
            products.map(function (item, idx) {
                return (react_1.default.createElement("div", { key: idx, className: 'bundle-item-block' },
                    react_1.default.createElement("div", { className: 'bundle-item-block--img-qty-container' },
                        react_1.default.createElement("div", { className: 'bundle-item-block--image-container' },
                            item.image_src && react_1.default.createElement("img", { src: item.image_src, alt: item.title }),
                            react_1.default.createElement("div", { className: 'bundle-item-block--quantity' }, item.quantity))),
                    react_1.default.createElement("div", { className: 'bundle-item-block--title-container' },
                        react_1.default.createElement("div", { className: (0, classnames_1.default)('bundle-item-block--title') },
                            react_1.default.createElement("span", null, (0, remove_ships_every_text_1.default)(item.title))),
                        item.variant_title && item.variant_title.toLowerCase() !== 'default title' && react_1.default.createElement("div", { className: 'bundle-item-block--option-name' }, item.variant_title))));
            })),
        react_1.default.createElement("hr", { className: 'border-seashell margin-0' }),
        react_1.default.createElement("div", { className: 'padding-6 text-right' },
            react_1.default.createElement("div", null,
                react_1.default.createElement("small", null, "Product total"),
                " ",
                (0, format_price_1.default)(orderToCancel.subtotal_price)),
            react_1.default.createElement("div", null,
                react_1.default.createElement("small", null, "Tax"),
                " ",
                (0, format_price_1.default)(orderToCancel.total_tax)),
            react_1.default.createElement("div", null,
                react_1.default.createElement("small", null, "Shipping"),
                " ",
                (0, format_price_1.default)(orderToCancel.shipping_lines.reduce(function (sum, l) { return sum + parseFloat(l.discounted_price); }, 0).toFixed(2))),
            react_1.default.createElement("div", null,
                react_1.default.createElement("small", null, "Order total"),
                " ",
                (0, format_price_1.default)(orderToCancel.total_price)))));
});
